<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      highlight-hover-row
      :data="data"
      :toolbar-config="tableToolbar"
      :columns="tableColumns"
      :loading="loading"
      :height="height"
      size="small"
      resizable
      border
      :editConfig="{
        trigger: 'manual',
        mode: 'row',
        showStatus: true
      }"
      @edit-closed="editClosedEvent"
      show-footer
      :footer-method="footerMethod"
      :header-cell-style="headerCellStyle"
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="side-frame-success">
            <span style="font-size: 14px; color: #606266">{{
              $l('INDEX.form_label_goods') || '产品信息'
            }}</span>
            <el-divider direction="vertical"></el-divider>
            <b-button
              class="mr-2"
              size="sm"
              :disabled="disabled"
              variant="outline-info"
              @click="openChooseOrderGoods()"
              >{{ $l('INDEX.tips_select_goods') || '选择产品' }}
            </b-button>
          </div>
        </slot>
      </template>
      <template v-slot:opt="{ row }">
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_edit') || '编辑'"
          placement="top"
          v-if="!disabled"
        >
          <i
            class="el-icon-edit tool-btn"
            @click="editRowEvent(row)"
            v-if="!disabled"
          ></i>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_del') || '删除'"
          placement="top"
          v-if="!disabled"
        >
          <i
            class="el-icon-delete tool-btn"
            v-if="!disabled"
            @click="remove(row)"
          ></i>
        </el-tooltip>
      </template>
    </vxe-grid>
    <choose-order-goods-dialog
      :visible.sync="visible"
      :title="
        $l('INDEX.order_goods_label_orderGoods_information') || '订单产品信息'
      "
      :changeOrderCode="changeOrderCode"
      type="checkbox"
      @confirm="confirm"
    />
  </div>
</template>
<script>
import ChooseOrderGoodsDialog from '@/views/factory/order/changeorder/choose-components/change-order-goods/dialog.vue'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: {
    ChooseOrderGoodsDialog
  },
  mixins: [EditLoading],

  props: {
    tableData: { type: Array, default: () => [] },
    height: { type: Number, default: 300 },
    disabled: { type: Boolean, default: false },
    changeOrderCode: { type: String, default: '' },
    code: { type: String, default: '' },
    expandDisabled: { type: Boolean, default: false }
  },
  mounted() {
    if (this.code) {
      this.setTableData()
    }
  },
  watch: {
    tableData: {
      handler(val) {
        this.data = val
      },
      immediate: true
    }
  },
  computed: {
    footerData() {
      if (!this.data) return 0
      var goosQty = 0
      this.data.forEach((item) => {
        goosQty += parseInt(item['goosQty'])
      })
      return [['合计', '', goosQty ? goosQty : 0, '']]
    }
  },
  data() {
    return {
      data: [],
      visible: false,
      loading: false,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        }
      },
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq'
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          headerAlign: 'center',
          align: 'center',
          fixed: 'left',
          width: 90,
          slots: {
            default: 'opt'
          }
        },
        {
          title: this.$l('INDEX.proofing_goods_label_goodsQty') || '样品数量',
          field: 'goosQty',
          width: 120,
          fixed: 'left',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
          editRender: {
            name: 'ElInputNumber',
            props: {
              controlsPosition: 'right',
              style: 'width:100%',
              min: 1,
              step: 1,
              precision: 0
            },
            placeholder: '请输入费用',
            immediate: true
          }
        },
        {
          title: this.$l('INDEX.order_goods_label_orderGoodsNo') || '产品编号',
          field: 'orderGoodsNo',
          width: 150,
          align: 'center',
          showOverflow: true,
          showHeaderOverflow: true
        },
        {
          title:
            this.$l('INDEX.order_goods_label_identifyGoodsNo') ||
            '产品识别编号',
          field: 'identifyGoodsNo',
          width: 230,
          headerAlign: 'center',
          align: 'left',
          showHeaderOverflow: true,
          showOverflow: true
        },
        {
          title:
            this.$l('INDEX.order_goods_label_orderGoodsName') || '产品名称',
          field: 'orderGoodsDisplayName',
          minWidth: 450,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true
        }
      ]
    }
  },
  methods: {
    headerCellStyle({ column, columnIndex }) {
      if (column.property !== 'xxx') {
        return {
          backgroundColor: '#bd94c1',
          color: '#ffffff'
        }
      }
    },
    footerMethod() {
      // 返回一个二维数组的表尾合计
      return this.footerData
    },
    setTableData() {
      this.loading = true
      this.$api
        .changeOrderProofingGoodsListApi({
          orderProofingCode: this.code,
          changeOrderCode: this.changeOrderCode
        })
        .then((res) => {
          this.loading = false
          this.data = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    remove(row) {
      if (this.expandDisabled) {
        this.$confirm('您确定要删除该数据吗?').then((type) => {
          if (type === 'confirm') {
            this.$api
              .changeOrderProofingGoodsDelApi({
                changeOrderProofingGoodsCode: row.changeOrderProofingGoodsCode
              })
              .then(() => {
                this.$message({
                  showClose: true,
                  message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
                  type: 'success'
                })
                this.setTableData()
                this.$emit('reload')
              })
          }
        })
      } else {
        this.$confirm('您确定要删除该数据吗?').then((type) => {
          if (type === 'confirm') {
            let index = this.$refs.vxeGrid.getRowIndex(row)
            this.tableData.splice(index, 1)
          }
        })
        this.$emit('update:tableData', this.tableData)
      }
    },
    openChooseOrderGoods() {
      this.visible = true
    },
    goodsSpecDialogClose() {
      this.visible = false
    },
    editRowEvent(row) {
      const $grid = this.$refs.vxeGrid
      $grid.setActiveRow(row)
    },
    editClosedEvent({ row }) {
      if (this.expandDisabled) {
        this.loadingOpen()
        this.$api
          .changeOrderProofingGoodsEditApi({
            ...row
          })
          .then((res) => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'success'
            })
            this.setTableData()
            this.$emit('reload')
          })
          .catch(() => {
            this.loadingClose()
          })
      }
    },
    confirm(params) {
      if (this.expandDisabled) {
        var info = params
          .map((t) => ({
            orderGoodsCode: t.orderGoodsCode,
            goosQty: 1,
            orderGoodsDisplayName: t.orderGoodsDisplayName,
            changeOrderCode: t.changeOrderCode,
            orderGoodsNo: t.orderGoodsNo,
            identifyGoodsNo: t.identifyGoodsNo
          }))
          .filter(
            (i) =>
              this.data.findIndex(
                (j) => j.orderGoodsCode === i.orderGoodsCode
              ) < 0
          )
        if (info.length === 0) {
          this.$message({
            showClose: true,
            message: '数据已存在',
            type: 'error'
          })
          return
        }
        this.loadingOpen()
        this.$api
          .changeOrderProofingGoodsSaveApi({
            items: info,
            orderProofingCode: this.code,
            changeOrderCode: this.changeOrderCode,
          })
          .then((res) => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'success'
            })
            this.setTableData()
            this.$emit('reload')
          })
          .catch(() => {
            this.loadingClose()
          })
      } else {
        var infos = params
          .map((t) => ({
            orderGoodsCode: t.orderGoodsCode,
            goosQty: 1,
            orderGoodsDisplayName: t.orderGoodsDisplayName,
            changeOrderCode: t.changeOrderCode,
            orderGoodsNo: t.orderGoodsNo,
            identifyGoodsNo: t.identifyGoodsNo
          }))
          .filter(
            (i) =>
              this.tableData.findIndex(
                (j) => j.orderGoodsCode === i.orderGoodsCode
              ) < 0
          )
        infos.push.apply(infos, this.tableData)
        this.$emit('update:tableData', infos)
      }
    }
  }
}
</script>
